var map = {
	"./badminton-image.jpg": 187,
	"./basketball-image.jpg": 188,
	"./football-image.jpg": 189,
	"./squash-image.jpg": 190,
	"./tabletennis-image.jpg": 191,
	"./tennis-image.jpg": 192,
	"./volleyball-image.jpg": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;